'use client';

import SettingConfig from '@module/config/setting';
import {
  programManyCamGuideOne,
  programManyCamGuideTwo,
  programXSplitGuideStepOne,
  programXSplitManycamCombinationGuideStepOne,
  programXSplitManycamCombinationGuideStepTwo,
  programXSplitYouCamCombinationGuideStepOne,
  programXSplitYouCamCombinationGuideStepTwo,
  programYouCamGuideStepOne,
  programYoucamManycamCombinationGuideStepOne,
  programYoucamManycamCombinationGuideStepTwo,
} from '@module/constants/guide';
import { cn } from '@module/lib/utils';
import { IcoDownload, IcoManyCam } from '@module/svg/icons';
import GuideCarouselCard from '@pc/components/card/GuideCarouselCard';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@pc/components/ui/carousel';
import { useState } from 'react';

function PcProgramGuideContainer() {
  const [tab, setTab] = useState<'manyCam' | 'YouCam' | 'XSplit' | 'combination'>('manyCam');

  return (
    <div>
      <div className='mt-4 mb-10 text-colorFg18'>
        <button
          type='button'
          className={cn('relative font-semibold', {
            'text-colorFg22 after:absolute after:top-0 after:h-1 after:w-1 after:rounded-[50%] after:bg-colorFg22 after:content-[""]':
              tab === 'manyCam',
          })}
          onClick={() => setTab('manyCam')}
        >
          매니캠(Many Cam)
        </button>
        <button
          type='button'
          className={cn('relative ml-6 font-semibold', {
            'text-colorFg22 after:absolute after:top-0 after:h-1 after:w-1 after:rounded-[50%] after:bg-colorFg22 after:content-[""]':
              tab === 'YouCam',
          })}
          onClick={() => setTab('YouCam')}
        >
          유캠(You Cam)
        </button>
        <button
          type='button'
          className={cn('relative ml-6 font-semibold', {
            'text-colorFg22 after:absolute after:top-0 after:h-1 after:w-1 after:rounded-[50%] after:bg-colorFg22 after:content-[""]':
              tab === 'XSplit',
          })}
          onClick={() => setTab('XSplit')}
        >
          엑스스플릿(XSplit)
        </button>
        <button
          type='button'
          className={cn('relative ml-6 font-semibold', {
            'text-colorFg22 after:absolute after:top-0 after:h-1 after:w-1 after:rounded-[50%] after:bg-colorFg22 after:content-[""]':
              tab === 'combination',
          })}
          onClick={() => setTab('combination')}
        >
          연동사용
        </button>
      </div>
      <div className='mb-10 flex items-center justify-between'>
        {tab === 'manyCam' && (
          <>
            <div className='flex flex-col'>
              <span className='mb-2 text-colorFg02 text-xl'>매니캠(Many Cam)</span>
              <span className='text-[15px] text-colorFg09'>
                단순한 조작법 및 간단한 기능들로 타 프로그램 보다 권장사양이 낮아 저사양의 컴퓨터에서도 가볍게 구동이
                가능합니다.
              </span>
            </div>
            <a
              href='https://manycam.com/'
              className='flex items-center rounded-lg border border-borderBg18 bg-colorBg15 px-5 text-[17px] text-colorFg04 leading-[46px]'
              target='_blank'
              rel='noreferrer'
            >
              <IcoManyCam />
              <span className='mr-2 ml-1'>매니캠</span>
              <IcoDownload style={{ color: 'var(--colorFg04)' }} />
            </a>
          </>
        )}
        {tab === 'YouCam' && (
          <>
            <div className='flex flex-col'>
              <span className='mb-2 text-colorFg02 text-xl'>유캠(You Cam)</span>
              <span className='text-[15px] text-colorFg09'>
                확대, 축소 등 얼굴 자동 인식 초점 기능이 특화된 프로그램으로 리액션 화면에 많이 활용되며 주로 XSplit과
                연동하여 사용합니다.
              </span>
            </div>
            <a
              href='https://kr.cyberlink.com/products/youcam/features_ko_KR.html'
              className='flex items-center rounded-lg border border-borderBg18 bg-colorBg15 px-5 text-[17px] text-colorFg04 leading-[46px]'
              target='_blank'
              rel='noreferrer'
            >
              <img width={20} src={`${SettingConfig.S3_BUCKET_URL}/img/guide/youcam.png`} alt={'youcam'} />
              <span className='mr-2 ml-1'>유캠</span>
              <IcoDownload style={{ color: 'var(--colorFg04)' }} />
            </a>
          </>
        )}
        {tab === 'XSplit' && (
          <>
            <div className='flex flex-col'>
              <span className='mb-2 text-colorFg02 text-xl'>엑스스플릿(XSplit)</span>
              <span className='text-[15px] text-colorFg09'>
                전문적인 화면전환 및 효과로 기능의 난이도 및 권장사양이 높으며, 화질이 정확하고 선명해 고품질 방송이
                가능합니다. 방송 도우미 기능 활용 시 필수로 사용합니다.
              </span>
            </div>
            <a
              href='https://www.xsplit.com/'
              className='flex items-center rounded-lg border border-borderBg18 bg-colorBg15 px-5 text-[17px] text-colorFg04 leading-[46px]'
              target='_blank'
              rel='noreferrer'
            >
              <img width={20} src={`${SettingConfig.S3_BUCKET_URL}/img/guide/xsplit.png`} alt={'xsplit'} />
              <span className='mr-2 ml-1'>엑스스플릿</span>
              <IcoDownload style={{ color: 'var(--colorFg04)' }} />
            </a>
          </>
        )}
        {tab === 'combination' && (
          <>
            <div className='flex flex-col'>
              <span className='mb-2 text-colorFg02 text-xl'>연동사용</span>
              <span className='text-[15px] text-colorFg09'>
                2가지 이상의 캠 프로그램을 연동하여 사용할 경우 필요한 기능들을 조합해 방송에 활용할 수 있습니다.
              </span>
              <span className='text-red-500'>(아래 설정방법은 프로그램 순서를 반대로도 설정할 수 있습니다.)</span>
            </div>
            <div className='flex gap-2'>
              <a
                href='https://manycam.com/'
                className='flex items-center rounded-lg border border-borderBg18 bg-colorBg15 px-5 text-[17px] text-colorFg04 leading-[46px]'
                target='_blank'
                rel='noreferrer'
              >
                <IcoManyCam />
                <span className='mr-2 ml-1'>매니캠</span>
                <IcoDownload style={{ color: 'var(--colorFg04)' }} />
              </a>
              <a
                href='https://kr.cyberlink.com/products/youcam/features_ko_KR.html'
                className='flex items-center rounded-lg border border-borderBg18 bg-colorBg15 px-5 text-[17px] text-colorFg04 leading-[46px]'
                target='_blank'
                rel='noreferrer'
              >
                <img width={20} src={`${SettingConfig.S3_BUCKET_URL}/img/guide/youcam.png`} alt={'youcam'} />
                <span className='mr-2 ml-1'>유캠</span>
                <IcoDownload style={{ color: 'var(--colorFg04)' }} />
              </a>
              <a
                href='https://www.xsplit.com/'
                className='flex items-center rounded-lg border border-borderBg18 bg-colorBg15 px-5 text-[17px] text-colorFg04 leading-[46px]'
                target='_blank'
                rel='noreferrer'
              >
                <img width={20} src={`${SettingConfig.S3_BUCKET_URL}/img/guide/xsplit.png`} alt={'xsplit'} />
                <span className='mr-2 ml-1'>엑스스플릿</span>
                <IcoDownload style={{ color: 'var(--colorFg04)' }} />
              </a>
            </div>
          </>
        )}
      </div>
      {tab === 'manyCam' && (
        <Carousel>
          <CarouselContent className='h-[640px]'>
            <CarouselItem>
              <GuideCarouselCard data={programManyCamGuideOne} />
            </CarouselItem>
            <CarouselItem>
              <GuideCarouselCard data={programManyCamGuideTwo} />
            </CarouselItem>
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>
      )}
      {tab === 'YouCam' && (
        <Carousel>
          <CarouselContent className='h-[640px]'>
            <CarouselItem>
              <GuideCarouselCard data={programYouCamGuideStepOne} continueList />
            </CarouselItem>
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>
      )}
      {tab === 'XSplit' && (
        <Carousel>
          <CarouselContent className='h-[640px]'>
            <CarouselItem>
              <GuideCarouselCard data={programXSplitGuideStepOne} />
            </CarouselItem>
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>
      )}
      {tab === 'combination' && (
        <>
          <div>
            <p className='mb-6 font-semibold text-colorFg02 text-xl'>1. 엑스스플릿 + 유캠</p>
            <Carousel>
              <CarouselContent className='h-[640px]'>
                <CarouselItem>
                  <GuideCarouselCard data={programXSplitYouCamCombinationGuideStepOne} />
                </CarouselItem>
                <CarouselItem>
                  <GuideCarouselCard data={programXSplitYouCamCombinationGuideStepTwo} />
                </CarouselItem>
              </CarouselContent>
              <CarouselPrevious />
              <CarouselNext />
            </Carousel>
          </div>
          <div className='mt-[45px]'>
            <p className='mb-6 font-semibold text-colorFg02 text-xl'>2. 엑스스플릿 + 매니캠</p>
            <Carousel>
              <CarouselContent className='h-[640px]'>
                <CarouselItem>
                  <GuideCarouselCard data={programXSplitManycamCombinationGuideStepOne} />
                </CarouselItem>
                <CarouselItem>
                  <GuideCarouselCard data={programXSplitManycamCombinationGuideStepTwo} />
                </CarouselItem>
              </CarouselContent>
              <CarouselPrevious />
              <CarouselNext />
            </Carousel>
          </div>
          <div className='mt-[45px]'>
            <p className='mb-6 font-semibold text-colorFg02 text-xl'>3. 유캠 + 매니캠</p>
            <Carousel>
              <CarouselContent className='h-[640px]'>
                <CarouselItem>
                  <GuideCarouselCard data={programYoucamManycamCombinationGuideStepOne} />
                </CarouselItem>
                <CarouselItem>
                  <GuideCarouselCard data={programYoucamManycamCombinationGuideStepTwo} />
                </CarouselItem>
              </CarouselContent>
              <CarouselPrevious />
              <CarouselNext />
            </Carousel>
          </div>
        </>
      )}
    </div>
  );
}

export default PcProgramGuideContainer;
